// CrosshairPreloader.tsx  (or just put it directly in ThreeScene.tsx)
import React from 'react';
import { createPortal } from 'react-dom';
import Constants from '../../constants';

const svgUrl = '/icons/crosshair.svg'; // Adjust path – use your actual path

export const CROSSHAIR_SIZE_PX = 100;

const CrosshairPreloader: React.FC = () => {
  return createPortal(
    <img
      id={Constants.UI_CROSSHAIR_ID}
      src={svgUrl}
      alt="crosshair preload"
      style={{
        position: 'absolute',
        left: '1em',
        top: '1em',
        width: `${CROSSHAIR_SIZE_PX}px`,
        height: `${CROSSHAIR_SIZE_PX}px`,
        opacity: 0.5,
        pointerEvents: 'none',
        userSelect: 'none',
        display: 'none' // Hidden initially
      }}
      
    />,
    document.body
  );
};

export default CrosshairPreloader;